import Layout from "../components/Layout";
import AirfieldDetails from "../pages/Airfields/AirfieldDetails";
import AirfieldPublicIndex from "../pages/Airfields/AirfieldPublicIndex";
import HomePage from "../pages/HomePage";
import React from "react";
import ExternalFlightInput from "../pages/ExternalFlightInput";


const MainRoutes = {
    path: "/",
    element: (
        <Layout />
    ),
    children: [
        {
            path: "/",
            element: <AirfieldPublicIndex />,
        },
        {
            path: "/details",
            element: <AirfieldDetails />,
        },
        {
            path: "/externalFlightInput/:tenantId",
            element: <ExternalFlightInput />,
        },


    ],
};

export default MainRoutes;
